//@flow
import React from 'react';
import SessionActions from '../../Actions/session';

export default function FacebookButton() {
  return (
    <button className="facebook-button cta" onClick={SessionActions.loginWithFB}>Sign in with Facebook</button>
  );
}
